<template>
<div>
    <v-row class="ma-2">Περιοχές Ενδιαφέροντος</v-row>
    <v-row class="ma-2">
        
        <div v-for="name in selectedCamps" :key="name">
            <v-chip
                class="ma-2"
                close
                @click:close="deselect(name)">
            {{ name }}
            </v-chip>
        </div>

        <v-select
            v-if="!hideDropdownList"
            v-model="selectedCamp"
            @change="mark"
            :items="availableCampsEligibleForSelection"
            label="Προσθήκη Περιοχής"
            single-line
            dense
            outlined
        ></v-select>


        <p v-if="error !== ''">{{ error }}</p>
    </v-row>
  </div>
</template>

<script>
// pull down user's camps and select between them
export default {
  name: "CampPicker",
  props: {
        camps: { // camps provided for initialization
            type: Array,
            default: () => []
        },
        disabled: { // if immutable
            type: Boolean,
            default: false,
            required: false
        },
        limit: { // usually set this to 1 just for 1 camp
            type: Number,
            required: false,
            default: 1000
        },
        clearCampSelTrigger: {
            type: Number,
            required: false,
            default: 0
        }
    },
  data: () => {
    return {
      availableCamps: [],
      selectedCamps: [],
      selectedCamp: '',
      error: '',
      canViewCamps: false
    };
  },
  watch: {
      camps(newVal) {
        //   console.log("[WATCH]: camps")
        //   console.log(newVal)
          this.selectedCamps = newVal
      },
      clearCampSelTrigger: {
          immediate: true,
          /*eslint-disable-next-line*/
          handler(newVal, oldVal) {
            // console.log("[WATCH]: trigger")
            // console.log(`${oldVal} -> ${newVal}`)
            this.selectedCamp = ""
          }
      }
  },
  async mounted() {
      this.canViewCamps = this.$store.state.user.isAdmin
        || this.$store.state.user.isCampMaster
      this.selectedCamps = this.camps
    // console.log('user already existing camps: ')
    // console.log(this.camps)]

    if (!this.canViewCamps) {
        return
    }

    try {
        const response = await this.$axios.get('/camps')
        // console.log('backend camps to be made available: ')
        // console.log(response.data)
        this.availableCamps = response.data

        this.error = ""
    } catch (e) {
        console.log(e.response.data)
        this.error = e.response.data
    }
  },
  computed: {
      availableCampsEligibleForSelection() {
        const self = this
        // console.log("Eligibility filtering:")
        // console.log(self.selectedCamps)
        // console.log(self.availableCamps)
        return this.availableCamps.filter(x => !self.selectedCamps.includes(x))
      },
      hideDropdownList() {
          return this.disabled || this.selectedCamps.length >= this.limit || !this.canViewCamps
      }
  },
  methods: {
      mark(name) {
          if (this.hideDropdownList) {
              return
          }

          this.selectedCamps = this.selectedCamps.concat([name])
      },
      deselect(name) {
          if (this.disabled || !this.canViewCamps) {
              return
          }
          
          this.selectedCamps = this.selectedCamps.filter(x => x !== name)
      }
  },
};
</script>
